import { NavigatorScreenParams, ParamListBase } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { ICONS } from 'components/Icon';
import { StyleProp, TextStyle } from 'react-native';
import { FileTypeGroupsEnum } from 'service/file/types';
import {
  AssessmentItemTypes,
  InstanceParentParams,
  Action as AssessmentAction,
  Control as AssessmentControl,
} from 'store/assessments/types';
import { AssessmentTemplate } from 'store/remote/types';
import { ApiUser, ApiWebhook } from 'types/Api';
import {
  AseSetupFlag as TypeAseSetupFlag,
  AseSetupSignatory as TypeAseSetupSignatory,
} from 'types/Assessments';
import { BillingStatus } from 'types/Billing';
import {
  EngagePropertyListItem,
  EngageScheduledVisitListItem,
} from 'types/Engage';
import {
  EngageDocument,
  EngageElement,
  EngageElementCheck,
  EngageMessaging,
  EngageReportIssue,
} from 'types/EngageSettings';
import {
  AssessmentQuestionType,
  DueDeterminedBy,
  FieldResult,
  FieldTypeKey,
  MonthEnum,
  SelectOption,
  TimescaleArray,
  UID,
  UUID,
} from 'types/types';
import { EngageContactEvacuationInfo } from 'types/DTOs/BlockManagerDTOs';
import { Action } from 'typesafe-actions';

type PageOptions = { id: string; name: string }[];

export enum Stacks {
  ROOT = 'ROOT',

  TAB = 'TAB',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  SETTINGS = 'SETTINGS',

  PROFILEEMAIL = 'PROFILEEMAIL',

  CREATEASSET = 'CREATEASSET',
  SYNC = 'SYNC',
  ORGANISATIONS = 'ORGANISATIONS',
  ORGANISATION = 'ORGANISATION',
  ASSET = 'ASSET',
  ASSETFIELDREPEATABLE = 'ASSETFIELDREPEATABLE',

  // Assessment Setup Library
  ASSESSMENTSETUPLIBRARY = 'ASSESSMENTSETUPLIBRARY',
  ASSESSMENTSETUPLIBRARYEXPLORER = 'ASSESSMENTSETUPLIBRARYEXPLORER',

  ASSESSMENT = 'ASSESSMENT',
  ASEREPEATABLE = 'ASSESSMENTREPEATABLE',

  // Engage (Block Management)
  Engage = 'Engage',
}

export enum ModalScreens {
  ReportsSelect = 'ReportsSelect',
  ReportsFilterModal = 'ReportsFilterModal',

  CLOUDASSETS = 'CLOUDASSETS',
  CREATEASSET = 'CREATEASSET',
  SYNCERRORS = 'SYNCERRORS',
  QR_VIEWER = 'QR_VIEWER',
  QR_SCANNER = 'QR_SCANNER',
  PLANS = 'PLANS',
  PLANLIST = 'PLANLIST',
  PLANINFO = 'PLANINFO',
  PLANCREATE = 'PLANCREATE',
  SELECT = 'SELECT',
  Support = 'Support',
  REORDER = 'REORDER',
  Sync = 'Sync',
  UpgradeRequired = 'UpgradeRequired',
  PDFVIEWER = 'PDFVIEWER',
  FILEMANAGER = 'FILEMANAGER',
  NEWREPEATABLEINSTANCE = 'NEWREPEATABLEINSTANCE',

  Camera = 'Camera',

  // Asset
  FIELDINSTANCESOPTIONS = 'FIELDINSTANCESOPTIONS',
  AstLightRepeatableInstance = 'AstLightRepeatableInstance',

  // Assessments
  CREATEASSESSMENT = 'CREATEASSESSMENT',
  ASEEXPLOREROPTIONS = 'ASEEXPLOREROPTIONS',
  ASEHISTORY = 'ASEHISTORY',
  ASEFINDINGBELONGSTO = 'ASEFINDINGBELONGSTO',
  AseSummary = 'AseSummary',
  AseSection = 'AseSection',
  AseInstanceCheck = 'AseInstanceCheck',
  AseQuestion = 'AseQuestion',
  AseAction = 'AseAction',
  AseControl = 'AseControl',
  ASECOPY = 'ASECOPY',
  ASERISKRATING = 'ASERISKRATING',
  AseAuthor = 'AseAuthor',
  ASEREPEATABLEINSTANCENEWFROMLIST = 'ASEREPEATABLEINSTANCENEWFROMLIST',
  AseFieldInstancesOptions = 'AseFieldInstancesOptions',
  AseQuickAnswerChecklist = 'AseQuickAnswerChecklist',
  AseQuickAnswerQuestion = 'AseQuickAnswerQuestion',
  AseMakeSuggestion = 'AseMakeSuggestion',
  AseStatusApprove = 'AseStatusApprove',
  AseStatusUnapprove = 'AseStatusUnapprove',
  AseStatusUnsubmit = 'AseStatusUnsubmit',
  AseLightRepeatableInstance = 'AseLightRepeatableInstance',
  AseFieldInstance = 'AseFieldInstance',
  AseFields = 'AseFields',
  AseAssetDetails = 'AseAssetDetails',
  AseFlag = 'AseFlag',
  AseFlagUnset = 'AseFlagUnset',

  AseSignatory = 'AseSignatory',
  // AseFlagUnset = 'AseFlagUnset',

  // Settings - Assessment - Checks
  SettingsAseCheck = 'SettingsAseCheck',

  // Assessment Setup Template
  ASESETUPTEMPLATE = 'ASESETUPTEMPLATE',
  ASESETUPTEMPLATEQUESTIONLIST = 'ASESETUPTEMPLATEQUESTIONLIST',
  ASESETUPTEMPLATEFIELDS = 'ASESETUPTEMPLATEFIELDS',

  // Assessment Setup Library
  ASESETUPLIBRARYFOLDER = 'ASESETUPLIBRARYFOLDER',
  ASESETUPLIBRARYSECTION = 'ASESETUPLIBRARYSECTION',
  ASESETUPLIBRARYQUESTION = 'ASESETUPLIBRARYQUESTION',
  ASESETUPLIBRARYCHECKLISTITEM = 'ASESETUPLIBRARYCHECKLISTITEM',
  ASESETUPLIBRARYANSWER = 'ASESETUPLIBRARYANSWER',
  ASESETUPLIBRARYACTIONSLIST = 'ASESETUPLIBRARYACTIONSLIST',
  ASESETUPLIBRARYCONTROLSLIST = 'ASESETUPLIBRARYCONTROLSLIST',
  ASESETUPLIBRARYACTION = 'ASESETUPLIBRARYACTION',
  ASESETUPLIBRARYCONTROL = 'ASESETUPLIBRARYCONTROL',
  ASESETUPLIBRARYLINKQUESTIONS = 'ASESETUPLIBRARYLINKQUESTIONS',
  AseSetupFlags = 'AseSetupFlags',
  AseSetupFlag = 'AseSetupFlag',

  AseSetupSignatories = 'AseSetupSignatories',
  AseSetupSignatory = 'AseSetupSignatory',

  // Assessments Online
  AsesListFilter = 'AsesListFilter',

  // Field Settings
  FieldSettingsSection = 'FieldSettingsSection',
  FieldSettingsGroup = 'FieldSettingsGroup',
  FieldSettingsGroupCheck = 'FieldSettingsGroupCheck',
  FieldSettingsLiteGroup = 'FieldSettingsLiteGroup',
  FieldSettingsField = 'FieldSettingsField',
  FieldSettingsFieldCriteria = 'FieldSettingsFieldCriteria',
  FieldSettingsSectionLinkCustomer = 'FieldSettingsSectionLinkCustomer',

  // Profile
  SETTINGSPROFILEDETAILS = 'SETTINGSPROFILEDETAILS',
  SETTINGSPROFILEEMAIL = 'SETTINGSPROFILEEMAIL',
  SETTINGSPROFILEPASSWORD = 'SETTINGSPROFILEPASSWORD',
  SETTINGSPROFILETFA = 'SETTINGSPROFILETFA',

  SettingsApiUser = 'SettingsApiUser',
  SettingsApiWebhook = 'SettingsApiWebhook',
  SettingsEngageDocument = 'SettingsEngageDocument',
  SettingsEngageElement = 'SettingsEngageElement',
  SettingsEngageCheck = 'SettingsEngageCheck',
  SettingsEngageReportIssue = 'SettingsEngageReportIssue',
  SettingsEngageMessaging = 'SettingsEngageMessaging',

  SettingsBillingOrganisation = 'SettingsBillingOrganisation',
  SettingsBillingProduct = 'SettingsBillingProduct',
  SettingsBillingProductUnits = 'SettingsBillingProductUnits',
  SettingsBillingItem = 'SettingsBillingItem',
  SettingsBillingDiscount = 'SettingsBillingDiscount',

  SettingsSsoIdp = 'SettingsSsoIdp',

  SettingsOrganisationDetailsModal = 'SettingsOrganisationDetailsModal',
  SettingsOrganisationBillingModal = 'SettingsOrganisationBillingModal',

  EngageFlatsFilter = 'EngageFlatsFilter',
  EngageFlat = 'EngageFlat',
  EngageContact = 'EngageContact',
  EngageContactEmergencyEvacuation = 'EngageContactEmergencyEvacuation',
  EngageSendCommunication = 'EngageSendCommunication',
  EngageContactUpload = 'EngageContactUpload',
  EngageFlatDoorScheduledVisit = 'EngageFlatDoorScheduledVisit',
  EngageCancelScheduledVisit = 'EngageCancelScheduledVisit',
}

export enum Screens {
  RootError = 'RootError',
  ROOT_AUTH = 'ROOT_AUTH',
  ROOT_TAB = 'ROOT_TAB',
  ROOT_ASSESSMENT = 'ROOT_ASSESSMENT',
  ROOT_ASEREPEATABLE = 'ROOT_ASEREPEATABLE',
  ROOT_AUTHDIALOG = 'ROOT_AUTHDIALOG',

  TAB_OFFLINE = 'TAB_OFFLINE',
  TAB_ASSESSMENTS = 'TAB_ASSESSMENTS',
  TAB_SETTINGS = 'TAB_SETTINGS',
  TabReporting = 'TabReporting',

  OFFLINE_ASSETS = 'OFFLINE_ASSETS',
  OFFLINE_ASSET = 'OFFLINE_ASSET',

  SETTINGS_EXPLORER = 'SETTING_EXPLORER',
  SETTINGS_PROFILE = 'SETTING_PROFILE',
  SETTINGS_ORGANISATION = 'SETTINGS_ORGANISATION',
  SETTINGS_FIELDS = 'SETTINGS_FIELDS',
  SettingsGeneral = 'SettingsGeneral',
  SETTINGS_QUESTIONS = 'SETTINGS_QUESTIONS',
  SETTINGS_ASSESSMENTS = 'SETTINGS_ASSESSMENTS',
  SettingsAssessmentCompliance = 'SettingsAssessmentCompliance',
  SETTINGS_PLACEHOLDER = 'SETTINGS_PLACEHOLDER',
  SETTINGS_BILLING = 'SETTINGS_BILLING',
  SettingsBillingAdmin = 'SettingsBillingAdmin',
  SettingsApi = 'SettingsApi',
  SettingsEngage = 'SettingsEngage',
  SettingsSso = 'SettingsSso',

  ORGANISATIONS_SUMMARY = 'ORGANISATIONS_SUMMARY',
  ORGANISATIONS_ORGANISATION = 'ORGANISATIONS_ORGANISATION',

  ORGANISATION_EXPLORER = 'ORGANISATION_EXPLORER',
  ORGANISATION_SUMMARY = 'ORGANISATION_SUMMARY',
  ORGANISATION_FIELDSETTINGS = 'ORGANISATION_FIELDSETTINGS',

  ASSET_EXPLORER = 'ASSET_EXPLORER',
  ASSET_SUMMARY = 'ASSET_SUMMARY',
  ASSET_FIELDSTANDARD = 'ASSET_FIELDSTANDARD',
  ASSET_FIELDREPEATABLE = 'ASSET_FIELDREPEATABLE',
  ASSET_COMPLIANCE = 'ASSET_COMPLIANCE',
  ASSETFIELDREPEATABLE_LIST = 'ASSETFIELDREPEATABLE_LIST',
  ASSETFIELDREPEATABLE_INSTANCE = 'ASSETFIELDREPEATABLE_INSTANCE',
  ASSETFIELDSTANDARD_INSTANCE = 'ASSETFIELDSTANDARD_INSTANCE',

  ASESETUPLIBRARYEXPLORER = 'ASESETUPLIBRARYEXPLORER',
  ASESETUPLIBRARYWELCOME = 'ASESETUPLIBRARYWELCOME',
  ASESETUPLIBRARYFOLDER = 'ASESETUPLIBRARYFOLDER',

  ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS = 'ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS',
  ASSESSMENTSETUPLIBRARYEXPLORERSECTIONS = 'ASSESSMENTSETUPLIBRARYEXPLORERSECTIONS',

  ASE_EXPLORER = 'ASE_EXPLORER',
  ASE_ASSET = 'ASE_ASSET',
  ASE_SUMMARY = 'ASE_SUMMARY',
  ASE_SECTION = 'ASE_SECTION',
  ASE_QUESTION = 'ASE_QUESTION',
  ASE_ACTION = 'ASE_ACTION',
  ASE_CONTROL = 'ASE_CONTROL',
  ASE_FIELDS = 'ASE_FIELDS',

  ASEREPEATABLE_LIST = 'ASEREPEATABLE_EXPLORER',
  ASEREPEATABLE_INTRO = 'ASEREPEATABLE_INTRO',
  ASEREPEATABLE_INSTANCE = 'ASEREPEATABLE_INSTANCE',
  AseInstanceCheck = 'AseInstanceCheck',
  ASEREPEATABLE_QUESTION = 'ASEREPEATABLE_QUESTION',
  ASEREPEATABLE_ACTION = 'ASEREPEATABLE_ACTION',
  ASEREPEATABLE_CONTROL = 'ASEREPEATABLE_CONTROL',

  SELECT = 'SELECT',

  EngageProperties = 'EngageProperties',
  EngageFlats = 'EngageFlats',
  EngageScheduledVisits = 'EngageScheduledVisits',
}

export interface NavigationStacks extends Record<Stacks, ParamListBase> {
  [Stacks.Engage]: {
    [Screens.EngageProperties]: { pageKey: string };
    [Screens.EngageFlats]: {
      pageKey: string;
      property: EngagePropertyListItem;
    };
    [Screens.EngageScheduledVisits]: {
      pageKey: string;
      property: EngagePropertyListItem;
    };
  };

  [Stacks.ROOT]: {
    [Screens.RootError]: undefined;
    [Screens.ROOT_AUTH]: undefined;
    [Screens.ROOT_TAB]: NavigatorScreenParams<NavigationStacks[Stacks.TAB]>;
    [Screens.ROOT_ASSESSMENT]: {
      assessmentId: string;
    };
    [Screens.ROOT_ASEREPEATABLE]: {
      groupId: string;
      parent: InstanceParentParams;
    };
    [Screens.ROOT_AUTHDIALOG]: undefined;

    // Reports
    [ModalScreens.ReportsSelect]: {};
    [ModalScreens.ReportsFilterModal]: {
      reportKey: string;
    };

    // Other

    [ModalScreens.SYNCERRORS]: {};
    [ModalScreens.CREATEASSET]: {
      organisations: PageOptions;
    };
    [ModalScreens.CLOUDASSETS]: {
      show: true;
    };
    [ModalScreens.FILEMANAGER]: {
      eventKey: string;
      multiSelect: boolean;
      promptMessage: string;
      limitSelectionToFileGroups?: FileTypeGroupsEnum[];
    };
    [ModalScreens.UpgradeRequired]: {
      major: boolean;
      withClose: boolean;
    };
    [ModalScreens.Sync]: {};
    [ModalScreens.PDFVIEWER]: {
      title: string;
      sourceUrl: string;
    };
    [ModalScreens.PLANS]: { show: true };
    [ModalScreens.PLANLIST]: {};
    [ModalScreens.PLANINFO]: {};
    [ModalScreens.PLANCREATE]: {};
    [ModalScreens.QR_SCANNER]: {};
    [ModalScreens.QR_VIEWER]: {
      data: string;
      deleteKey?: string;
    };
    [ModalScreens.Camera]: {
      assetId: string;
      eventKey: string;
    };
    [ModalScreens.SELECT]: {
      options: (SelectOption | '-')[];
      title?: string;
      titleNumberOfLines?: number;
      text?: string;
      eventKeyAdded?: string;
      searchable?: boolean;
      enableSelectAll?: boolean;
      requireValue?: boolean;
      optionNoun?: string;
      closeOnDone?: boolean;
      hideRadioButton?: boolean;
      showDoneButtonForSingleSelect?: boolean;
      submitOnSelection?: boolean;
      saveButtonText?: string;
      cancelButtonText?: string;
    } & (
      | {
          fieldName: string;
          incomingValueKey: string;
          returnType: 'string';
          value?: string;
          multiSelect?: false;
          eventKey?: undefined;
          showQuickChoose?: never;
        }
      | {
          fieldName: string;
          incomingValueKey: string;
          returnType: 'number';
          value?: number;
          multiSelect?: false;
          eventKey?: undefined;
          showQuickChoose?: never;
        }
      | {
          fieldName: string;
          incomingValueKey: string;
          returnType?: 'array';
          value?: string[] | number[];
          multiSelect?: boolean;
          eventKey?: undefined;
          showQuickChoose?: never;
        }
      | {
          eventKey: string;
          returnType?: 'array';
          value?: string[] | number[];
          multiSelect?: boolean;
          fieldName?: undefined;
          incomingValueKey?: undefined;
          showQuickChoose?: boolean;
        }
    );
    [ModalScreens.Support]: {};
    [ModalScreens.REORDER]: {
      options: {
        value: number | string;
        name: string;
        valueStyle?: StyleProp<TextStyle>;
        icon?: ICONS;
        iconColor?: string;
      }[];
      title?: string;
      subtitle?: string;
      description?: string;
      text?: string;
      closeOnDone?: boolean;
    } & (
      | {
          eventKey?: undefined;
          action: Action;
        }
      | {
          eventKey: string;
          action?: Action;
        }
    );
    [ModalScreens.NEWREPEATABLEINSTANCE]: {
      assetId: string;
      groupId: string;
      initValues?: Record<string, string | string[]>;
    };
    [ModalScreens.AseAssetDetails]: {};
    [ModalScreens.AseFlag]: {
      flagId: string;
    };
    [ModalScreens.AseFlagUnset]: {
      flagId: string;
    };
    [ModalScreens.AseSignatory]: {
      signatoryId: string;
    };
    [ModalScreens.AstLightRepeatableInstance]: {
      assetId: UUID;
      groupId: string;
      instanceId: string;
      parent: InstanceParentParams;
    };
    [ModalScreens.AseFieldInstance]: {
      groupId: string;
      instanceId: string | undefined;
      initValues?: Record<string, string | string[]>;
      isAddingExisting?: boolean;
      parent: InstanceParentParams;
      initResults?: Record<string, FieldResult>;
      isEditable?: boolean;
    };
    [ModalScreens.AseLightRepeatableInstance]: {
      groupId: string;
      instanceId: string | undefined;
      parent: NonNullable<InstanceParentParams>;
      // initValues?: Record<string, string | string[]>;
    };
    [ModalScreens.AseFieldInstancesOptions]: {
      groupId: string;
      listType: 'adding' | 'added';
    };
    [ModalScreens.ASEREPEATABLEINSTANCENEWFROMLIST]: {
      groupId: string;
      parent: InstanceParentParams;
    };
    // Root Assessment Modals
    [ModalScreens.CREATEASSESSMENT]: {
      assetId: string;
      complianceSubtypeId: string;
    };
    [ModalScreens.ASEEXPLOREROPTIONS]: {};
    [ModalScreens.FIELDINSTANCESOPTIONS]: {
      organisationId: UUID;
      groupId: string;
    };
    [ModalScreens.AseControl]: {
      id: string;
      isDuplicate?: boolean;
      parent: InstanceParentParams;
      data: AssessmentControl;
    };
    [ModalScreens.AseSummary]: {};
    [ModalScreens.AseSection]: {
      id: string;
    };
    [ModalScreens.AseInstanceCheck]: {
      id: string;
      instanceId: string;
    };
    [ModalScreens.AseQuestion]: {
      id: string;
      fieldInstanceId: string | null;
      parent: InstanceParentParams;
    };
    [ModalScreens.AseFields]: {
      groupId: string;
    };
    [ModalScreens.AseAction]: {
      id: string;
      isDuplicate?: boolean;
      parent: InstanceParentParams;
      data: AssessmentAction;
    };
    [ModalScreens.AseQuickAnswerChecklist]: {
      instructions: string;
      questionId: string;
      fieldInstanceId: string | null;
      actionsAfter: Action[]; // action after answering checklist
    };
    [ModalScreens.AseQuickAnswerQuestion]: {
      instructions: string;
      questionId: string;
      fieldInstanceId: string | null;
      actionsAfter: Action[]; // action after answering checklist
    };
    [ModalScreens.ASEFINDINGBELONGSTO]: {
      findingType: AssessmentItemTypes;
      incomingValueKey?: string;
      eventKey: string;
      sectionId: string | null;
      questionId: string | null;
      fieldInstanceId: string | null;
    };
    [ModalScreens.ASEHISTORY]: { id: string; findingType: string };
    [ModalScreens.ASECOPY]: {};
    [ModalScreens.ASERISKRATING]: {
      eventKey: string;
      data: {
        riskLikelihoodId: string;
        riskSeverityId: string;
        riskChangeReason: boolean;
        riskReason: string;
      };
    };
    [ModalScreens.AseAuthor]: {
      eventKey: string;
      data: {
        id: string;
        name: string;
        email: string;
        role: string;
      };
    };
    [ModalScreens.AseMakeSuggestion]: {
      type: 'action' | 'control';
      questionId: string;
      description: string;
      why: string;
      categoryId: string;
      timescaleId: string;
      severityId: string;
      dueDeterminedBy: DueDeterminedBy;
      dueTimescale: TimescaleArray | null;
      dueTypeId: string | null;
      answerId?: string;
      checklistItemId?: number;
      cost: string;
    };
    [ModalScreens.AseStatusApprove]: {};
    [ModalScreens.AseStatusUnapprove]: {};
    [ModalScreens.AseStatusUnsubmit]: {};

    [ModalScreens.SettingsAseCheck]: {
      id: string;
    };
    // Assessment Setup Template
    [ModalScreens.ASESETUPTEMPLATE]: {
      newData?: {
        complianceSubtypeId: number;
      };
    };
    [ModalScreens.ASESETUPTEMPLATEQUESTIONLIST]: {
      eventKey: string;
      questionIds: number[];
    };
    [ModalScreens.ASESETUPTEMPLATEFIELDS]: {
      eventKey: string;
      organisationId: UID;
      fieldsConfig: AssessmentTemplate['fieldsConfig'];
    };
    [ModalScreens.AseSetupFlags]: {};
    [ModalScreens.AseSetupFlag]: { flag: TypeAseSetupFlag | null };
    [ModalScreens.AseSetupSignatories]: {};
    [ModalScreens.AseSetupSignatory]: {
      signatory: TypeAseSetupSignatory | null;
    };

    // Assessments Online
    [ModalScreens.AsesListFilter]: {};

    // Assessment Setup Library
    [ModalScreens.ASESETUPLIBRARYFOLDER]: {
      id: number | undefined;
    };
    [ModalScreens.ASESETUPLIBRARYSECTION]: {
      folderId: number | undefined; // on add
    };
    [ModalScreens.ASESETUPLIBRARYQUESTION]: {
      type: AssessmentQuestionType | null; // on add
      sectionId: number | null; // on add
      parentQuestionId: number | null; // on add
    };
    [ModalScreens.ASESETUPLIBRARYCHECKLISTITEM]: {
      questionId: number | null; // on add
    };
    [ModalScreens.ASESETUPLIBRARYANSWER]: {
      questionId: number | null; // on add
    };
    [ModalScreens.ASESETUPLIBRARYACTIONSLIST]: {
      incomingValueKey: string;
      hideIds: number[];
    };
    [ModalScreens.ASESETUPLIBRARYCONTROLSLIST]: {
      incomingValueKey: string;
      hideIds: number[];
    };
    [ModalScreens.ASESETUPLIBRARYACTION]: {
      incomingValueNewIdKey: string | undefined;
      allowLinkManagement: boolean;
    };
    [ModalScreens.ASESETUPLIBRARYCONTROL]: {
      incomingValueNewIdKey: string | undefined;
      allowLinkManagement: boolean;
    };
    [ModalScreens.ASESETUPLIBRARYLINKQUESTIONS]: {
      hideIds: number[];
    };

    // Field Settings
    [ModalScreens.FieldSettingsSection]: {};
    [ModalScreens.FieldSettingsGroup]: {
      isLite?: false;
      newData?: {
        repeatable: boolean;
      };
    };
    [ModalScreens.FieldSettingsGroupCheck]: {
      eventKey: string;
      data: {
        id: string | null;
        name: string;
        typeId: string;
        action: 'create' | 'delete' | null;
      };
    };
    [ModalScreens.FieldSettingsLiteGroup]: {
      isLite: true;
      newData: {
        repeatable: true;
      };
    };
    [ModalScreens.FieldSettingsField]: {
      newData?: {
        type: FieldTypeKey;
        multiSelect?: boolean;
      };
    };
    [ModalScreens.FieldSettingsSectionLinkCustomer]: {
      sectionId: string;
      sectionName: string;
      organisations: { id: string; name: string }[];
    };
    [ModalScreens.FieldSettingsFieldCriteria]: {
      groupId: string;
      fieldId: string;
      fieldName: string;
      selectionKey: string;
      criteria: {
        fieldId: string;
        value: string[];
        operator: 'includes';
      }[];
    };

    // Profile
    [ModalScreens.SETTINGSPROFILEDETAILS]: {
      name: string;
      forename: string;
      phone: string;
      postNominals: string;
      qualifications: string;
      surname: string;
      features: {
        edit: boolean;
      };
    };
    [ModalScreens.SETTINGSPROFILEEMAIL]: { features: { edit: boolean } };
    [ModalScreens.SETTINGSPROFILEPASSWORD]: {};
    [ModalScreens.SETTINGSPROFILETFA]:
      | {
          enabled: true;
          enabledTime: number;
          secret: null;
          uri: null;
          required: null;
        }
      | {
          enabled: false;
          enabledTime: null;
          secret: string;
          uri: string;
          required: { date: number } | null;
        };

    // Engage Settings
    [ModalScreens.SettingsEngageDocument]: {
      document: EngageDocument;
    };
    [ModalScreens.SettingsEngageElement]: {
      element: EngageElement;
    };
    [ModalScreens.SettingsEngageCheck]: {
      eventKey: string;
      check: EngageElementCheck;
    };
    [ModalScreens.SettingsEngageReportIssue]: {
      reportIssue: EngageReportIssue;
    };
    [ModalScreens.SettingsEngageMessaging]: {
      messaging: EngageMessaging;
    };

    // API Settings
    [ModalScreens.SettingsApiUser]:
      | {
          type: 'new';
          data: {
            token: string;
            bearerToken: string;
            organisationId: UID;
          };
        }
      | {
          type: 'existing';
          data: {
            id: string;
            organisationId: UID;
            name: string;
            createdTs: ApiUser['createdTs'];
            expireTs: ApiUser['expireTs'];
            expiredTs: ApiUser['expiredTs'];
            lastAccessedTs: ApiUser['lastAccessedTs'];
          };
        };
    [ModalScreens.SettingsApiWebhook]:
      | {
          type: 'new';
          data: {
            organisationId: UID;
          };
        }
      | {
          type: 'existing';
          data: {
            id: string;
            organisationId: UID;
            url: string;
            hasSecret: boolean;
            createdTs: ApiWebhook['createdTs'];
            lastRequestTs: ApiWebhook['lastRequestTs'];
            lastRequestStatus: ApiWebhook['lastRequestStatus'];
            lastRequestErrorNumber: ApiWebhook['lastRequestErrorNumber'];
          };
        };

    // Billing
    [ModalScreens.SettingsBillingOrganisation]: {
      status: BillingStatus;
      invoicePrefix: string;
      invoicePaymentTermsDays: number;
      assessmentInvoiceMonths: MonthEnum[];
      hasFreeAssessments: boolean;
    };
    [ModalScreens.SettingsBillingProduct]: {
      productId: string | null;
    };
    [ModalScreens.SettingsBillingProductUnits]: {
      productId: string;
    };
    [ModalScreens.SettingsBillingItem]: {
      itemId: string | null;
    };
    [ModalScreens.SettingsBillingDiscount]: {
      itemId: string | null;
    };

    // SSO
    [ModalScreens.SettingsSsoIdp]: {};

    // Organisation Settings
    [ModalScreens.SettingsOrganisationDetailsModal]: {
      organisationId: UID;
      name: string;
      address1: string;
      address2: string;
      city: string;
      county: string;
      postcode: string;
      phone: string;
      website: string;
      approveRequireAddress: boolean;
      approveRequireLogo: boolean;
      approveRequirePhone: boolean;
      approveRequireWebsite: boolean;
      userFeatures: {
        editName: boolean;
        editAddress: boolean;
        editPhone: boolean;
        editWebsite: boolean;
        editApproveRequires: boolean;
      };
    };
    [ModalScreens.SettingsOrganisationBillingModal]: {
      organisationId: UID;
      name: string;
      address1: string;
      address2: string;
      city: string;
      county: string;
      postcode: string;
      emails: string;
      emailsPo: string;
    };
    [ModalScreens.EngageFlatsFilter]: {
      pageKey: string;
      propertyId: string;
    };
    [ModalScreens.EngageFlat]: {
      key: string;
    };
    [ModalScreens.EngageContact]: {
      key: string;
      contactId: string | null;
    };
    [ModalScreens.EngageContactEmergencyEvacuation]: {
      key: string;
      contactName: string;
      contactId: string;
      flatId: string;
      propertyId: string;
      data: EngageContactEvacuationInfo;
    };
    [ModalScreens.EngageSendCommunication]: {
      key: string;
      propertyId: string;
      flatIds: string[];
    } & (
      | {
          contactId: string | null;
          mode: 'singleFlat' | 'bulkFlat';
        }
      | {
          contactId: null;
          mode: 'bulkFlat';
        }
    );
    [ModalScreens.EngageContactUpload]: {
      key: string;
      propertyId: string;
    };
    [ModalScreens.EngageFlatDoorScheduledVisit]: {
      propertyId: string;
      pageKey: string;
      scheduledVisit?: EngageScheduledVisitListItem;
    };
    [ModalScreens.EngageCancelScheduledVisit]: {
      propertyId: string;
      pageKey: string;
      scheduledVisitId: string;
    };
  };

  [Stacks.TAB]: {
    [Screens.TAB_OFFLINE]: NavigatorScreenParams<
      NavigationStacks[Stacks.OFFLINE]
    >;
    [Screens.TAB_ASSESSMENTS]: undefined;
    [Screens.TAB_SETTINGS]: NavigatorScreenParams<
      NavigationStacks[Stacks.SETTINGS]
    >;
  };
  [Stacks.OFFLINE]: {
    [Screens.OFFLINE_ASSETS]: undefined;
    [Screens.OFFLINE_ASSET]: { id: string };
  };
  [Stacks.SETTINGS]: {
    [Screens.SETTINGS_EXPLORER]: undefined;
    [Screens.SettingsGeneral]: undefined;
    [Screens.SETTINGS_PROFILE]: undefined;
    [Screens.SETTINGS_ORGANISATION]: undefined;
    [Screens.SETTINGS_FIELDS]: undefined;
    [Screens.SETTINGS_QUESTIONS]: undefined;
    [Screens.SETTINGS_ASSESSMENTS]: undefined;
    [Screens.SettingsAssessmentCompliance]: undefined;
    [Screens.SETTINGS_BILLING]: undefined;
    [Screens.SettingsBillingAdmin]: undefined;
    [Screens.SettingsApi]: undefined;
    [Screens.SettingsEngage]: undefined;
    [Screens.SettingsSso]: undefined;
  };
  /** @todo remove this stack */
  [Stacks.ORGANISATIONS]: {
    [Screens.ORGANISATIONS_SUMMARY]: undefined;
    [Screens.ORGANISATIONS_ORGANISATION]: { id: string };
  };
  /** @todo remove this stack */
  [Stacks.ORGANISATION]: {
    [Screens.ORGANISATION_EXPLORER]: {
      id: string;
    };
    [Screens.ORGANISATION_SUMMARY]: {
      id: string;
    };
    [Screens.ORGANISATION_FIELDSETTINGS]: {
      id: string;
    };
  };
  [Stacks.ASSET]: {
    [Screens.ASSET_FIELDSTANDARD]: {
      assetId: string;
      groupId: string;
      sectionId: string;
    };
    [Screens.ASSET_FIELDREPEATABLE]: {
      assetId: string;
      groupId: string;
      sectionId: string;
    };
    [Screens.ASSET_EXPLORER]: {
      assetId: string;
    };
    [Screens.ASSET_SUMMARY]: {
      assetId: string;
    };
    [Screens.ASSET_COMPLIANCE]: {
      complianceTypeId: string;
      assetId: string;
    };
  };
  [Stacks.ASSETFIELDREPEATABLE]: {
    [Screens.ASSETFIELDREPEATABLE_LIST]: {
      assetId: string;
      groupId: string;
      sectionId: string;
    };
    [Screens.ASSETFIELDREPEATABLE_INSTANCE]: {
      instanceId: string;
      assetId: string;
      groupId: string;
    };
  };
  [Stacks.ASSESSMENTSETUPLIBRARY]: {
    [Screens.ASESETUPLIBRARYEXPLORER]: undefined;
    [Screens.ASESETUPLIBRARYWELCOME]: undefined;
    [Screens.ASESETUPLIBRARYFOLDER]: undefined;
  };
  [Stacks.ASSESSMENTSETUPLIBRARYEXPLORER]: {
    [Screens.ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS]: undefined;
    [Screens.ASSESSMENTSETUPLIBRARYEXPLORERSECTIONS]: {
      id: number;
    };
  };
  [Stacks.ASSESSMENT]: {
    [Screens.ASE_EXPLORER]: undefined;
    [Screens.ASE_SUMMARY]: {};
    [Screens.ASE_FIELDS]: { groupId: string };
    [Screens.ASE_ASSET]: {};
    [Screens.ASE_SECTION]: { id: string };
    [Screens.ASE_QUESTION]: {
      id: string;
      fieldInstanceId: null;
      parent: InstanceParentParams;
    };
    [Screens.ASE_ACTION]: {
      id: string;
      isDuplicate?: true;
      parent: InstanceParentParams;
      data: AssessmentAction;
    };
    [Screens.ASE_CONTROL]: {
      id: string;
      isDuplicate?: true;
      parent: InstanceParentParams;
      data: AssessmentControl;
    };
  };
  [Stacks.ASEREPEATABLE]: {
    [Screens.ASEREPEATABLE_LIST]: {
      groupId: string;
      parent: InstanceParentParams;
    };
    [Screens.ASEREPEATABLE_INTRO]: {
      groupId: string;
      parent: InstanceParentParams;
    };
    [Screens.ASEREPEATABLE_INSTANCE]: {
      groupId: string;
      instanceId: string | undefined;
      prompt?: string;
      initValues?: Record<string, string | string[]>;
      isAddingExisting?: boolean;
      parent: InstanceParentParams;
      initResults?: Record<string, FieldResult>;
      /** @default true */
      isEditable?: boolean;
    };
    [Screens.ASEREPEATABLE_QUESTION]: {
      id: string;
      fieldInstanceId: string;
      parent: InstanceParentParams;
    };
    [Screens.AseInstanceCheck]: { id: string; instanceId: string };
    [Screens.ASEREPEATABLE_ACTION]: {
      id: string;
      isDuplicate?: true;
      parent: InstanceParentParams;
      data: AssessmentAction;
    };
    [Screens.ASEREPEATABLE_CONTROL]: {
      id: string;
      isDuplicate?: true;
      parent: InstanceParentParams;
      data: AssessmentControl;
    };
  };
}

export type ScreenProps<
  S extends Stacks,
  SK extends keyof NavigationStacks[S],
  NS extends NavigationStacks[S] = NavigationStacks[S],
> = {
  route: Pick<NativeStackScreenProps<NS, SK>['route'], 'params'>;
  navigation: Pick<
    NativeStackScreenProps<NS, SK>['navigation'],
    'setOptions' | 'goBack'
  >;
  isModal?: undefined;
};

export type ModalScreenProps<T extends ModalScreens> = {
  route: Pick<
    NativeStackScreenProps<NavigationStacks[Stacks.ROOT], T>['route'],
    'params'
  >;
  navigation?: NativeStackScreenProps<
    NavigationStacks[Stacks.ROOT],
    T
  >['navigation'];
  isModal?: true;
};
